module.exports = __webpack_public_path__ + "static/media/ico-accepted.71c77fe4.svg";